/**
 * Image loader for Next.js Image component
 */
const svcImageLoader = ({
  src,
  width,
  quality,
}: {
  src: string;
  width: number;
  quality?: number;
}): string => {
  return `${src}?w=${width}&q=${quality || 75}&fm=webp`;
};

export default svcImageLoader;
